import { ExperimentalWeb3ActionConfig } from 'types/Web3';

export const satisfiesExperimentalWeb3ActionConfig = <
  Config extends ExperimentalWeb3ActionConfig,
>(
  config: Config
) => config;
